import { SET_DATA_IS_OBJECT } from './types';

export const setDataIsObject = (isObject = false) => ({
  type: SET_DATA_IS_OBJECT,
  isObject,
});
